import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-table-cell-toggle',
  templateUrl: './toggle-table-cell.component.html',
  standalone: false,
})
export class ToggleTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  ngOnDestroy() {}
}
